

























import { Vue, Component } from 'vue-property-decorator';
import BudtenderCard from '@/components/budtender/BudtenderCard.vue';
import SlideshowView from '@/components/brand/brand_center/SlideshowView.vue';
import { CarouselSlide, MenuCard } from '../../common/types';

@Component({
  components: {
    BudtenderCard,
    SlideshowView,
  },
})
export default class BudtenderMenuPage extends Vue {
  menuCards: Array<MenuCard> = [
    {
      title: 'Brand Quiz',
      page: '/budtenders/brand',
      img: require('@/assets/bhang_art_3.jpg'),
    },
    {
      title: 'Product Quiz',
      page: '/budtenders/product',
      img: require('@/assets/bhang_art_2.jpg'),
    },
    {
      title: 'Merch Market',
      page: '/merch',
      img: require('@/assets/bhang_art.jpg'),
    },
  ];

  splashSlides: Array<CarouselSlide> = [
    { img: '', title: 'BUDTENDER OF THE MONTH', page: '' },
  ];
}
